import axios from 'axios';

const api = axios.create({
  baseURL: '/wp-json/wc/store/v1/',
});

export default api
